export const GROUP_COLORS = [
  '#E3F2FD', // Light blue
  '#F3E5F5', // Light purple
  '#E8F5E9', // Light green
  '#FFF3E0', // Light orange
  '#FCE4EC', // Light pink
  '#E0F2F1', // Light teal
  '#FFF9C4', // Light yellow
  '#EFEBE9', // Light brown
];

export const GROUP_BORDER_COLORS = [
  '#90CAF9', // Medium blue
  '#CE93D8', // Medium purple
  '#A5D6A7', // Medium green
  '#FFCC80', // Medium orange
  '#F48FB1', // Medium pink
  '#80CBC4', // Medium teal
  '#FFF59D', // Medium yellow
  '#BCAAA4', // Medium brown
];

export const getGroupColor = (
  groupIndex: number,
  isGrouped: boolean
): string => {
  if (!isGrouped) return 'transparent';
  return GROUP_COLORS[groupIndex % GROUP_COLORS.length];
};

export const getGroupBorderColor = (
  groupIndex: number,
  isGrouped: boolean
): string => {
  if (!isGrouped) return 'grey.400';
  return GROUP_BORDER_COLORS[groupIndex % GROUP_BORDER_COLORS.length];
};
